export default function notification() {
    if(document.querySelector(".notification")) {
        let notification = document.querySelector(".notification");

        notification.addEventListener("click", () => {
            notification.classList.toggle("is-active");
        });
    }
}